import { FullStory } from "@fullstory/browser";

export function setFullStoryProperties(props: Record<string, any>) {
  const { tenantId, customerName, linkId } = props;

  if (tenantId || customerName || linkId) {
    try {
      FullStory("setProperties", {
        type: "user",
        properties: {
          tenantId: tenantId ?? null,
          customerName: customerName ?? null,
          linkId: linkId ?? null,
        },
      });
    } catch (error) {
      if (process.env.NODE_ENV !== "test") {
        console.warn("FullStory not initialized:", error);
      }
    }
  }
}

export function setFullStoryIdentity(
  userId: string,
  properties?: Record<string, any>,
) {
  try {
    FullStory("setIdentity", {
      uid: userId,
      properties: properties ?? {},
    });
  } catch (error) {
    if (process.env.NODE_ENV !== "test") {
      console.warn("FullStory not initialized:", error);
    }
  }
}
